import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'DOWNLOAD_EXPENSE_REPORT';

export async function downloadExpenseReport(
    userToken: string,
    id:number
) {
    try {
        console.log("`${URL}/expense-reports/${id}/download/`", `${URL}/expense-reports/${id}/download/`);
      
        const response = await axios.get(
            `${URL}/expense-reports/${id}/download/`,
            {
                headers: {
                    Accept: 'application/json',
                    
                    Authorization: `Token ${userToken}`
                },
                responseType: 'blob'
            }
        );

        return response.data;
    }
    catch (error: any) {
        console.log(error);
        const errorMessage = () => {
            if (error.response.data.detail) {
                return error.response.data.detail;
            }
            else {
                return 'Une erreur est survenue lors du téléchargement d\'une note de frais';
            }
        };
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: errorMessage(),
            error: error
        });
    }
}
